import React from 'react';
import ModalButton from './ModalButton';

const SchoolAccountModal = ({school, proceed, closeModal})=>{
	return <div>
		<div>Thank you for your interest in Jumbletree LEARN.  <strong>{school.name}</strong>&nbsp;
		doesn't have an account yet, so we need to set a few things up.  By continuing today
		you'll be starting your school's two week free trial period.  During this trial period you'll
		be able to create as many homework sheets as you like!  If you wish to continue using
		Jumbletree LEARN after the two weeks you'll be able to sign up for a school account. </div>
		<ModalButton text="Start FREE TRIAL" onClick={proceed} showBail={true} bail={closeModal} />
	</div>
}

export default SchoolAccountModal;